<template>
  <div id="app">

    <b-container fluid class="m-0 p-0">
      <b-navbar class="w-100 p-0 app-nav" fixed="top">
        <b-nav class="w-100 px-2 pt-2 pb-0" tabs>
          <b-nav-item to="/" exact exact-active-class="active">Dashboard</b-nav-item>
          <b-nav-item to="/inventory" active-class="active">Inventory</b-nav-item>
          <b-nav-item to="/orders" active-class="active">Orders</b-nav-item>
          <b-nav-item to="/customers" active-class="active">Customers</b-nav-item>
          <b-nav-item to="/shipping" active-class="active">Shipping</b-nav-item>
          <b-nav-item v-if="$auth.user.nickname === 'tim' || $auth.user.nickname === 'edward' || $auth.user.nickname === 'craig'" to="/employees" active-class="active">Employees</b-nav-item>

          <b-nav-item-dropdown :text="$auth.user.name" class="ml-auto" id="userDropdown">
            <b-dropdown-item v-if="!isClockedIn" @click="doClock">Clock In</b-dropdown-item>
            <b-dropdown-item v-else @click="doClock">Clock Out</b-dropdown-item>
            <b-dropdown-item v-b-modal.timecardModal>Time Card</b-dropdown-item>
            <b-dropdown-item v-b-modal.ptoModal>Paid Time Off</b-dropdown-item>

            <b-dropdown-item @click="logout()">Logout</b-dropdown-item>
          </b-nav-item-dropdown>

        </b-nav>
      </b-navbar>

      <b-container fluid class="custom-padding site-content">
          <keep-alive exclude="Dashboard">
            <router-view></router-view>
          </keep-alive>
      </b-container>
    </b-container>

    <b-modal id="timecardModal"
             :title="timecardTitle()"
             size="md"
             scrollable
             button-size="sm"
             hide-footer
             centered>
      <b-row>

        <b-col align="right">
          <b-button :disabled="!payPeriods[payPeriodIndex + 1] || !payPeriods[payPeriodIndex + 1].start" @click="++payPeriodIndex" variant="outline-secondary" size="sm" tabindex="-1">
            <b-icon-chevron-compact-left></b-icon-chevron-compact-left>
          </b-button>

          <b-button :disabled="!payPeriods[payPeriodIndex - 1] || !payPeriods[payPeriodIndex - 1].start" @click="--payPeriodIndex" variant="outline-secondary" size="sm" tabindex="-1">
            <b-icon-chevron-compact-right></b-icon-chevron-compact-right>
          </b-button>
        </b-col>
      </b-row>

      <timecard :entries="entries" :paidTimeOff="paidTimeOff" @reloadTimecard="fetchTimecard()"></timecard>
    </b-modal>

    <b-modal id="ptoModal"
             title="Paid Time Off"
             size="lg"
             scrollable
             button-size="sm"
             hide-footer
             centered>
      <paid-time-off></paid-time-off>
    </b-modal>
  </div>
</template>

<script>
  import timecardApi from "@/api/timecard";
  import Timecard from "@/views/Timecard";
  import PaidTimeOff from "@/components/employees/PaidTimeOff";
  import timecardMixin from "@/mixins/timecard";

  export default {
    mixins: [ timecardApi, timecardMixin ],
    components: { Timecard, PaidTimeOff },
    async mounted() {

        this.$root.$on('bv::dropdown::show', async bvEvent => {
          if (bvEvent.componentId === 'userDropdown') {
            await this.fetchTimecard();
          }
        });


        this.handleEvents();
    },
    methods: {
      login() {
        this.$auth.loginWithRedirect();
      },
      logout() {
        this.$auth.logout({
          returnTo: window.location.origin
        });
      },
      handleEvents() {
        this.$root.$on('tabLink', (data) => { console.log(data) });
      },
    },
  }
</script>

<style>
  .menu-btn > button {
    padding-right: 0;
    padding-bottom: 0;
  }

  .header-menu-text {
    padding-top: 0.5rem;
  }

  .app-nav {
    z-index: 1000;
    background: #eee
  }

  .site-content {
    height: calc(100vh - 50px);
    overflow: auto;
    margin-top: 50px;
    padding-top: 20px;
  }

</style>